import type { Directive } from 'vue';

const mutationObsever = Symbol('mutation-obsever');

export const scrollbarActiveClass: Directive<HTMLDivElement, string> & {
  [mutationObsever]: MutationObserver | null;
} = {
  [mutationObsever]: null as MutationObserver | null,

  get mounted() {
    return (el: HTMLElement, { value }: { value: string }) => {
      this[mutationObsever] = new MutationObserver(() => {
        if (el.scrollHeight > el.clientHeight) {
          el.classList.add(...value.split(' '));
        }
        else {
          el.classList.remove(...value.split(' '));
        }
      });

      this[mutationObsever].observe(el, { childList: true, subtree: true });
    };
  },

  get beforeUnmount() {
    return () => {
      if (this[mutationObsever]) this[mutationObsever].disconnect();
    };
  },
};
